module.exports = __webpack_public_path__ + "static/home-9dcefc6dcf4cccee78409d435a6e2a50.jpg";